import { defineStore } from 'pinia';

// 从localStorage获取保存的邮箱
const getSavedEmail = (): string => {
  try {
    return localStorage.getItem('auth_email') || '';
  } catch (e) {
    return '';
  }
};

interface SharedState {
  email: string;
  loginStatusChanged: boolean; // 新增：登录状态变化标志
}

export const useSharedStore = defineStore('shared', {
  state: (): SharedState => ({
    email: getSavedEmail(),
    loginStatusChanged: false, // 新增：登录状态变化标志
  }),
  
  actions: {
    setEmail(email: string) {
      this.email = email;
      // 保存到localStorage
      try {
        localStorage.setItem('auth_email', email);
      } catch (e) {
        console.error('保存邮箱到本地存储失败', e);
      }
    },
    
    clearEmail() {
      this.email = '';
      // 从localStorage中移除
      try {
        localStorage.removeItem('auth_email');
      } catch (e) {
        console.error('从本地存储移除邮箱失败', e);
      }
    },

    // 新增：设置登录状态变化标志
    setLoginStatusChanged(changed: boolean) {
      this.loginStatusChanged = changed;
    },

    // 新增：监听其他标签页的登录状态变化
    initLoginStatusListener() {
      // 监听storage事件，检测其他标签页的登录状态变化
      window.addEventListener('storage', (event) => {
        if (event.key === 'token') {
          // 如果token发生变化，说明其他标签页完成了登录或登出
          if (event.newValue && !event.oldValue) {
            // 其他标签页登录了
            this.setLoginStatusChanged(true);
          } else if (!event.newValue && event.oldValue) {
            // 其他标签页登出了
            this.setLoginStatusChanged(true);
          }
        }
      });

      // 监听页面可见性变化，当用户切换回标签页时检查状态
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
          // 页面变为可见时，检查登录状态
          this.checkLoginStatusChange();
        }
      });
    },

    // 新增：检查登录状态是否发生变化
    checkLoginStatusChange() {
      const currentToken = localStorage.getItem('token');
      const lastKnownToken = sessionStorage.getItem('last_known_token');
      
      if (currentToken !== lastKnownToken) {
        // 登录状态发生变化
        this.setLoginStatusChanged(true);
        // 更新最后已知的token
        if (currentToken) {
          sessionStorage.setItem('last_known_token', currentToken);
        } else {
          sessionStorage.removeItem('last_known_token');
        }
      }
    },

    // 新增：清除登录状态变化标志
    clearLoginStatusChanged() {
      this.loginStatusChanged = false;
    }
  }
}); 